import React from "react"
import { Route } from "react-router-dom"
import PlanUUID from "src/containers/PlanUUID"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  PLANS_BY_UUID_URL,
  DEFAULT_UUID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

const WrappedPlanPage = withRouteValidation({
  routeValidationConfig: DEFAULT_UUID_VALIDATION_CONFIG,
})(PlanUUID)

export default <Route path={PLANS_BY_UUID_URL} component={WrappedPlanPage} />
